export const productCardStyles = {
  root: 'group flex h-full flex-col overflow-hidden rounded-lg border border-brand-700/15 bg-surface shadow-sm transition-shadow hover:shadow-md',
  clickable: 'cursor-pointer',
  imageWrap: 'flex aspect-[4/3] w-full items-center justify-center overflow-hidden bg-brand-100',
  image: 'h-full w-full object-contain transition-transform group-hover:scale-[1.03]',
  body: 'flex flex-1 flex-col gap-1.5 p-2.5 sm:p-3',
  title: 'font-heading text-sm font-semibold text-brand-950 line-clamp-2',
  meta: 'mt-auto flex items-start justify-between gap-2',
  action: 'mt-2',
} as const;
